<template>
  <div
    class="page-container"
    :class="{
      'page-container__mobile': isMobile || isMGAppInPad,
      'page-container__electron': isElectron,
    }"
  >
    <div class="header" v-if="!isHXApp">
      <span class="title">拼团-{{ courseInfo.course_name }}</span>
      <span class="header-back" @click="back"></span>
    </div>
    <!-- 拼团信息 -->
    <div
      class="active-info"
      :class="{
        'active-info__success': activeInfo.state === GROUP_SUCCESS,
        'active-info__fail': activeInfo.state === GROUP_FAIL,
        'active-info__no__group': activeInfo.state === NO_GROUP,
      }"
    >
      <div class="active-info-top">
        <div class="result">{{ groupResultLabel }}</div>
        <div class="count-down" v-if="activeInfo.state === NO_GROUP">
          拼团剩余 <span>{{ countdown.hours }}</span> :
          <span>{{ countdown.minutes }}</span> :
          <span>{{ countdown.seconds }}</span>
        </div>
      </div>
      <div class="active-info-list">
        <div class="active-info-message" v-html="userListMessage"></div>
        <div
          v-if="!isMobile && activeInfo.member_list.length + couldJoinNum > 8"
          @click="handleClickArrow('left')"
          class="arrow left-arrow"
        ></div>
        <div
          v-if="!isMobile && activeInfo.member_list.length + couldJoinNum > 8"
          @click="handleClickArrow('right')"
          class="arrow right-arrow"
        ></div>
        <div class="active-info-user-list" ref="userList">
          <div class="user-list">
            <div
              class="user-item"
              :class="{ 'user-item-leader': item.is_leader === 1 }"
              v-for="(item, index) in activeInfo.member_list || {}"
              :key="index"
            >
              <div class="avater"><img :src="item.avatar" alt="" /></div>
              <div class="name">{{ item.nickname.slice(0, 1) }}***</div>
              <div class="leader-tag" v-if="index === 0">团长</div>
              <div class="refund-tag" v-if="[1, 4].includes(item.state)">
                {{ item.state === 4 ? "已退款" : "待支付" }}
              </div>
            </div>

            <div
              class="join-box"
              v-for="(item, index) in new Array(couldJoinNum).fill(0)"
              :key="index + (activeInfo.member_list?.length || 0)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 课程卡片 -->
    <div class="course-info">
      <div class="left">
        <img :src="courseInfo.cover_url + '?imageView2/0/w/640'" alt="" />
      </div>
      <div class="right">
        <div class="course-name">{{ courseInfo.course_name }}</div>
        <div class="course-tag">
          <div class="tag" v-for="(item, index) in courseTag" :key="index">
            {{ item }}
          </div>
        </div>
        <div class="group-price">
          <div class="price">
            <span>￥</span>{{ (activeInfo.group_price / 100).toFixed(2) }}
          </div>
          <div class="origin-price">
            ￥{{ (courseInfo.goods?.price / 100).toFixed(2) }}
          </div>
          <div class="num">{{ activeInfo.group_num }}人起拼</div>
        </div>
        <div class="unit">
          {{ courseInfo.unit_count }}课时
          <span
            v-if="
              courseInfo.goods && courseInfo.goods.show_enrollment_count === 1
            "
            ><span class="separate"></span>
            {{ million(courseInfo.enrollment_count) }}人已学</span
          >
        </div>
        <div class="unit">
          课程有效期至：
          <span v-if="courseInfo.validity_type === 2"
            >随到随学{{ courseInfo.enrollment_days }}天</span
          >
          <span v-if="courseInfo.validity_type === 3">永久有效</span>
          <span v-if="courseInfo.validity_type === 1"
            >{{
              moment(courseInfo.course_end_time * 1000).format("YYYY年MM月DD日")
            }}
          </span>
        </div>
      </div>
    </div>
    <div class="footer">
      <div
        class="btn apply-btn"
        v-if="
          activeInfo.state === NO_GROUP &&
          myOrderInfo &&
          myOrderInfo.state !== 4
        "
        @click="handleApply"
      >
        邀请好友拼团
      </div>
      <div
        class="btn more-btn"
        v-if="activeInfo.state === GROUP_SUCCESS"
        @click="handleViewMore"
      >
        更多优惠课程
      </div>
      <div
        class="btn more-btn__fail"
        v-if="
          activeInfo.state === GROUP_FAIL ||
          (activeInfo.state === NO_GROUP && myOrderInfo.state === 4)
        "
        @click="handleViewMore"
      >
        <span>更多优惠课程</span>
      </div>
      <div
        class="btn view-btn"
        v-if="
          activeInfo.state === GROUP_FAIL ||
          (activeInfo.state === NO_GROUP && myOrderInfo.state === 4)
        "
        @click="handleViewCourse"
      >
        查看课程
      </div>
    </div>
  </div>
</template>

<script>
import info from "./info.js";
export default {
  mixins: [info],
};
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 100vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 100px;
  .header {
    width: 100%;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: $saas-text-color;
    background: #ffffff;
    position: relative;
    .title {
      display: inline-block;
      max-width: 700px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .header-back {
      position: absolute;
      width: 9px;
      height: 13px;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      background-image: url("../../../assets/images/group-activity/back-icon.png");
      cursor: pointer;
    }
  }
  .active-info {
    width: 800px;
    height: 318px;
    margin-top: 24px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    &.active-info__success {
      background-image: url("../../../assets/images/group-activity/success_bg.png");
    }
    &.active-info__fail {
      background-image: url("../../../assets/images/group-activity/fail_bg.png");
    }
    &.active-info__no__group {
      background-image: url("../../../assets/images/group-activity/no_group_bg.png");
    }
    .active-info-top {
      height: 102px;
      width: 100%;
      padding: 0 43px 0 48px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .result {
        height: 42px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 30px;
        color: $saas-text-color;
        line-height: 42px;
        text-align: left;
        font-style: normal;
        padding-top: 28px;
      }
      .count-down {
        padding-top: 30px;
        font-size: 22px;
        color: $saas-text-color;
        span {
          display: inline-block;
          width: 32px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          border-radius: 8px;
          background: $saas-text-color;
          color: #fff;
        }
      }
    }
    .active-info-list {
      width: 752px;
      height: 192px;
      background: #ffffff;
      border-radius: 24px;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
      .active-info-message {
        font-size: 22px;
        color: $saas-text-color;
        line-height: 24px;
        padding-top: 20px;
        padding-left: 24px;
      }
      .arrow {
        position: absolute;
        top: 44px;
        width: 24px;
        height: 132px;
        background: linear-gradient(
          90deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0.8) 100%
        );
        cursor: pointer;
        z-index: 10000;
      }
      .left-arrow {
        left: 0;
        background-image: url("../../../assets/images/group-activity/arrow.png");
        background-repeat: no-repeat;
        background-size: 16px 16px;
        background-position: center center;
      }
      .right-arrow {
        right: 0;
        background-image: url("../../../assets/images/group-activity/arrow.png");
        background-repeat: no-repeat;
        background-size: 16px 16px;
        background-position: center center;
        transform: rotate(180deg);
      }
      .active-info-user-list {
        width: 100%;
        margin-top: 24px;
        padding-right: 24px;
        scrollbar-width: 0;
        /* 标准语法，Firefox 支持 */
        -ms-overflow-style: none;
        /* IE 和 Edge */
        &::-webkit-scrollbar {
          display: none;
          /* WebKit 内核浏览器 */
        }
        scroll-snap-type: x mandatory;
        overflow-x: scroll;
        overflow-y: hidden;
        scroll-behavior: smooth;
        .user-list {
          display: inline-flex;
          flex-direction: row;
          flex-wrap: nowrap;
          min-width: 0;
        }
        .user-item {
          float: left;
          width: 80px;
          margin-left: 24px;
          position: relative;
          .avater {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            overflow: hidden;
            border: 1px solid #ffe3ef;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .name {
            margin-top: 6px;
            width: 100%;
            text-align: center;
            font-size: 16px;
            color: #747573;
            line-height: 22px;
          }
          .leader-tag {
            position: absolute;
            top: 56px;
            left: 50%;
            transform: translateX(-50%);
            width: 54px;
            height: 28px;
            background-image: url("../../../assets/images/group-activity/tag_bg.png");
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            font-size: 18px;
            color: #ffffff;
            text-align: center;
            z-index: 9;
          }
          .refund-tag {
            position: absolute;
            left: 0;
            top: 0;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            text-align: center;
            line-height: 80px;
            font-size: 16px;
            background: rgba(0, 0, 0, 0.4);
            border: 1px solid #ffe3ef;
            color: #fff;
          }
        }
        .user-item-leader {
          .avater {
            border-color: #ff3c74;
          }
        }
        .join-box {
          float: left;
          width: 80px;
          height: 80px;
          background-image: url("../../../assets/images/group-activity/add_btn.png");
          background-position: center center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          margin-left: 24px;
        }
      }
    }
  }
  .course-info {
    width: 800px;
    min-height: 226px;
    border-radius: 24px;
    background-color: #fff;
    margin-top: 24px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    padding: 24px 35px 24px 24px;
    .left {
      width: 320px;
      height: 180px;
      overflow: hidden;
      border-radius: 16px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .right {
      margin-left: 14px;
      flex: 1;
      .course-name {
        width: 100%;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 18px;
        color: $saas-text-color;
        line-height: 28px;
        text-align: left;
        font-style: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* 显示两行 */
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .course-tag {
        margin-top: 4px;
        min-height: 21px;
        overflow: hidden;
        .tag {
          float: left;
          padding: 0 4px;
          height: 21px;
          line-height: 21px;
          text-align: center;
          font-size: 12px;
          color: #00cb9b;
          background: #ebfff6;
          border-radius: 6px;
          margin-right: 4px;
          margin-top: 4px;
        }
      }
      .group-price {
        margin-top: 4px;
        height: 33px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        .price {
          line-height: 1;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 24px;
          color: #f03349;
          text-align: left;
          font-style: normal;
          span {
            font-size: 12px;
          }
        }
        .num {
          margin-left: 10px;
          box-sizing: border-box;
          height: 24px;
          line-height: 22px;
          border-radius: 8px;
          border: 1px solid rgba(240, 51, 73, 0.3);
          padding: 0 3px;
          font-size: 14px;
          color: #f03349;
        }
      }
      .origin-price {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #747573;
        line-height: 1;
        margin-bottom: 1px;
        text-align: left;
        font-style: normal;
        text-decoration-line: line-through;
        margin-left: 5px;
      }
      .unit {
        margin-top: 10px;
        height: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #747573;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        .separate {
          display: inline-block;
          width: 1px;
          height: 11px;
          background: #efefef;
          margin: 0 8px;
        }
      }
    }
  }
  .footer {
    padding: 0 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 800px;
    height: 100px;
    background: #ffffff;
    box-shadow: 0px -6px 16px 0px rgba(102, 116, 107, 0.1);
    border-radius: 24px 24px 0px 0px;
    position: fixed;
    bottom: 0;
    // left: 50%;
    // transform: translateX(-50%);
    .btn {
      height: 50px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
      font-style: normal;
      cursor: pointer;
    }
    .apply-btn {
      width: 179px;
      height: 50px;
      position: relative;
      padding-right: 8px;
      &::after {
        position: absolute;
        left: 0;
        top: -14px;
        content: "";
        width: 100%;
        height: 64px;
        background-image: url("../../../assets/images/group-activity/apply_btn_bg.png");
        background-repeat: no-repeat;
        background-size: 100% 64px;
        background-position: center center;
        z-index: -1;
      }
    }
    .more-btn {
      width: 161px;
      height: 50px;
      background-image: url("../../../assets/images/group-activity/common_btn_bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
    }
    .view-btn {
      width: 120px;
      height: 50px;
      background-image: url("../../../assets/images/group-activity/view_btn_bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      margin-left: 20px;
    }
    .more-btn__fail {
      width: 160px;
      height: 50px;
      background-image: url("../../../assets/images/group-activity/more_btn_bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      span {
        background: linear-gradient(
          to right,
          #00eb81,
          #00c89d
        ); /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
        -webkit-background-clip: text; /*将设置的背景颜色限制在文字中*/
        -webkit-text-fill-color: transparent; /*给文字设置成透明*/
      }
    }
  }
}
.page-container__mobile {
  min-height: 100vh;
  padding-bottom: 2.6667rem;
  padding-top: 1.04rem;
  background: #fff;
  .header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0 0.5333rem;
    height: 1.04rem;
    line-height: 1.04rem;
    font-size: 0.4rem;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.07);
    .header-back {
      width: 0.24rem;
      height: 0.3467rem;
      left: 0.2667rem;
    }
    .title {
      display: inline-block;
      max-width: 80%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .active-info {
    width: 9.36rem;
    height: 3.8933rem;
    margin-top: 0.32rem;
    &.active-info__success {
      background-image: url("../../../assets/images/group-activity/success_bg_h5.png");
    }
    &.active-info__fail {
      background-image: url("../../../assets/images/group-activity/fail_bg_h5.png");
    }
    &.active-info__no__group {
      background-image: url("../../../assets/images/group-activity/no_group_bg_h5.png");
    }
    .active-info-top {
      height: 1.1867rem;
      width: 100%;
      padding: 0 0.5467rem 0 0.5333rem;
      .result {
        height: 0.6rem;
        font-size: 0.4267rem;
        line-height: 0.6rem;
        padding-top: 0.32rem;
      }
      .count-down {
        padding-top: 0.36rem;
        font-size: 0.2933rem;
        span {
          width: 0.3733rem;
          height: 0.3733rem;
          line-height: 0.3733rem;
          border-radius: 0.0933rem;
        }
      }
    }
    .active-info-list {
      width: 8.8267rem;
      height: 2.44rem;
      border-radius: 0.28rem;
      .active-info-message {
        font-size: 0.32rem;
        line-height: 0.28rem;
        padding-top: 0.2267rem;
        padding-left: 0.2667rem;
      }
      .active-info-user-list {
        overflow: auto;
        margin-top: 0.24rem;
        padding-right: 0.32rem;
        .user-item {
          width: 1.0667rem;
          margin-left: 0.2933rem;
          .avater {
            width: 1.0667rem;
            height: 1.0667rem;
          }
          .name {
            margin-top: 0.08rem;
            font-size: 0.2133rem;
            line-height: 0.2933rem;
          }
          .leader-tag {
            top: 0.7467rem;
            width: 0.72rem;
            height: 0.3733rem;
            font-size: 0.24rem;
          }
          .refund-tag {
            width: 1.0667rem;
            height: 1.0667rem;
            line-height: 1.0667rem;
            font-size: 0.2133rem;
          }
        }
        .join-box {
          width: 1.0667rem;
          height: 1.0667rem;
          margin-left: 0.2933rem;
        }
      }
    }
  }
  .course-info {
    width: 9.3867rem;
    height: auto;
    margin-top: 0.32rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0;
    border-radius: 0;
    .left {
      width: 100%;
      height: 5.2267rem;
      border-radius: 0.32rem;
    }
    .right {
      margin-left: 0;
      margin-top: 0.2133rem;
      flex: auto;
      padding: 0 0.1467rem;
      .course-name {
        width: 100%;
        font-size: 0.4267rem;
        line-height: 0.6rem;
      }
      .course-tag {
        margin-top: 0.1067rem;
        min-height: 0.56rem;
        .tag {
          padding: 0 0.1067rem;
          height: 0.56rem;
          line-height: 0.56rem;
          font-size: 0.32rem;
          border-radius: 0.16rem;
          margin-top: 0.1067rem;
          margin-right: 0.1067rem;
        }
      }
      .group-price {
        margin-top: 0.1867rem;
        height: 0.6rem;
        .price {
          height: 0.6rem;
          line-height: 0.6rem;
          font-size: 0.4267rem;
          span {
            font-size: 0.2667rem;
          }
        }
        .num {
          margin-left: 0.16rem;
          height: 0.52rem;
          line-height: 0.52rem;
          border-radius: 0.16rem;
          padding: 0 0.1467rem;
          font-size: 0.2933rem;
        }
      }
      .origin-price {
        margin-top: 0.1333rem;
        height: 0.2933rem;
        font-size: 0.32rem;
        line-height: 0.2933rem;
      }
      .unit {
        margin-top: 0.2133rem;
        height: 0.4rem;
        font-size: 0.2933rem;
        line-height: 0.4rem;
      }
    }
  }
  .footer {
    padding: 0 0.4rem;
    width: 100%;
    height: 2.2667rem;
    border-radius: 0.32rem 0.32rem 0px 0px;
    .btn {
      height: 1.3333rem;
      font-size: 0.4267rem;
      line-height: 1.3333rem;
    }
    .apply-btn {
      width: 4.5067rem;
      height: 1.3333rem;
      padding-right: 0.1067rem;
      &::after {
        left: 0;
        top: -0.3733rem;
        content: "";
        width: 100%;
        height: 1.7067rem;
        background-size: 100% 1.7067rem;
      }
    }
    .more-btn {
      width: 4.2667rem;
      height: 1.3333rem;
    }
    .view-btn {
      width: 3.2rem;
      height: 1.3333rem;
    }
    .more-btn__fail {
      width: 4.2667rem;
      height: 1.3333rem;
    }
  }
}
.page-container__electron {
  .footer {
    // transform: translateX(-47%);
  }
}
</style>
